import { compose } from 'recompose';
import DropDownItem from './dropDownItem';

const enhance = compose();
export default enhance(DropDownItem);
